import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SeguridadService } from '../../services/seguridad.service';
import { XlsxService } from '../../services/utils/xlsx.service';

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.scss']
})
export class ListaComponent implements OnInit {

    @ViewChild('dt', {static: false}) dt!: any;

    @Input() cargando: boolean = false;

    @Input() fieldRowStatus: null
    @Input() fieldRowStatusValue: 0
    @Input() items: Record<string, any>[] = [];
    @Input() columns: Record<string, any>[] = [];
    @Input() recordName: string;
    @Input() name: string;
    @Input() pluralName: string;
    @Input() totalRecords: number;
    @Input() loading: boolean = false;
    @Input() modulo: string;
    @Input() codigoRegistro: string;


    @Output() getItems = new EventEmitter();
    @Output() create = new EventEmitter();
    @Output() edit = new EventEmitter();
    @Output() import = new EventEmitter();
    @Output() export = new EventEmitter();
    
    
    selectedItems: Record<string, any>[];
    rowsPerPageOptions = [10, 20, 50];
    filterValue: string;

    // Modal Dialog
    display = false;
    dialogFG!: FormGroup;

    crear: boolean = false;
    importar: boolean = false;
    exportar: boolean = false;

    importItems = [
        { label: 'Descargar Excel', icon: 'pi pi-file-excel', command: () => { this.downloadDocument() } },
    ]

    constructor(
        private fb: FormBuilder,
        private datePipe: DatePipe,
        private messageService: MessageService,
        private seguridadService: SeguridadService,
        private xlsService: XlsxService
    ) {
        // this.onItems();
    }
    
    ngOnInit(): void {
        this.checkPermisos();
        const stateStr = sessionStorage.getItem(this.recordName);
        if (stateStr) {
            const state = JSON.parse(stateStr);
            if ( state ) {
                this.filterValue = state?.filters?.global?.value;
                this.filterData(this.filterValue);
                // this.filterValueTemp = state?.globalFilter
            }
        }
    }

    async downloadDocument() {
        await this.xlsService.downloadDoc(this.recordName.split(".")[1]);
    }

    async checkPermisos() {
        this.crear = await this.seguridadService.puedeCrear(this.modulo, this.codigoRegistro);        
        this.importar = await this.seguridadService.puedeImportar(this.modulo, this.codigoRegistro);
        this.exportar = await this.seguridadService.puedeExportar(this.modulo, this.codigoRegistro);
    }

    async onItems( event?: any ) {
        await this.createDialogForm();
        // this.getItems.emit(event);
        this.getItems.emit();
        this.setSessionStorage(event)
    }

    // Metodo para emitir el evento de crear
    onCreate() {
        this.create.emit();
    }

    // Metodo para emitir el evento de editar
    onEdit( obj: Record<string, any> ) {
        this.edit.emit(obj);
    }

    // Metodo para emitir el evento de eliminar
    onDelete() {

    }

    // Metodo para importar
    onImport( event: any ) {
        if ( event.target.files.length > 0 ) {
            const file = event.target.files[0];
            event.target.value = '';
            const extension = file.name.split(".") as any[];
            if ( extension.includes('xlsx') || extension.includes('xls') ) {
                this.import.emit(file);
                return;
            }
            this.messageService.add({key: 'lista', severity: 'error', summary: 'Error', detail: 'Extensión no válida'});
        }
    }

    onExport() {
        this.export.emit();
    }

    // Metodo para crear los filtros en la sesion del usuario
    setSessionStorage( e?: any ) {
        if ( e ) {
            sessionStorage.setItem(this.recordName, JSON.stringify(e));
            sessionStorage.setItem(`${this.recordName}1`, JSON.stringify(e));
        }
        // { field: id, type: text, value: algo }
        const value: Record<string, any>[] = [];
        for (const col of this.columns) {
            if ( col.type === 'date' ) {
                const valueDesde = this.datePipe.transform(this.dialogFG.value[`desde_${col.field}`], 'yyyy-MM-dd')
                const valueHasta = this.datePipe.transform(this.dialogFG.value[`hasta_${col.field}`], 'yyyy-MM-dd')
                value.push({ field: `desde_${col.field}`, type: col.type, refName: col.refName, refField: col.refField, value: valueDesde })
                value.push({ field: `hasta_${col.field}`, type: col.type, refName: col.refName, refField: col.refField, value: valueHasta })
            } else if ( col.type === 'datetime' ) {
                const valueDesde = this.datePipe.transform(this.dialogFG.value[`desde_${col.field}`], 'yyyy-MM-dd HH:mm:ss')
                const valueHasta = this.datePipe.transform(this.dialogFG.value[`hasta_${col.field}`], 'yyyy-MM-dd HH:mm:ss')
                value.push({ field: `desde_${col.field}`, type: col.type, refName: col.refName, refField: col.refField, value: valueDesde })
                value.push({ field: `hasta_${col.field}`, type: col.type, refName: col.refName, refField: col.refField, value: valueHasta })
            } else {
                value.push({ field: col.field, type: col.type, refName: col.refName, refField: col.refField, value: this.dialogFG.value[col.field]});
            }
        }
        
        sessionStorage.setItem(`${this.recordName}_fields`, JSON.stringify(value));
    }

    // Formulario para filtros de las columnas
    async createDialogForm() {
        this.dialogFG = this.fb.group({});
        const fields = sessionStorage.getItem(`${this.recordName}_fields`);
        let jFields = JSON.parse(JSON.parse(JSON.stringify(fields))) as Record<string, any>[];    
        if ( !jFields ) { jFields = []; }
        for (const col of this.columns) {
            let field = jFields.filter( jField => jField.field === col.field );            
            let field2: Record<string, any> = [];
            if ( col.type === 'date' || col.type === 'datetime' ) {
                field = jFields.filter( jField => jField.field === `desde_${col.field}` );
                field2 = jFields.filter( jField => jField.field === `hasta_${col.field}` );
            }
            let formControl = new FormControl();
            let formControl2 = new FormControl();
            if ( field.length > 0 ) {
                if ( col.type === 'date' && field[0].value ) {
                    formControl = new FormControl( new Date(`${field[0].value} 00:00:00`) )
                } else if ( col.type === 'datetime' && field[0].value ) {
                    formControl = new FormControl( new Date( field[0].value ) );
                } else {
                    formControl = new FormControl( field[0].value );
                }
            }
            if ( field2.length > 0 ) {
                if ( col.type === 'date' && field2[0].value ) {
                    formControl2 = new FormControl( new Date(`${field2[0].value} 00:00:00`) )
                } else if ( col.type === 'datetime' && field2[0].value ) {
                    formControl2 = new FormControl( new Date( field2[0].value ) );
                } else {
                    formControl2 = new FormControl( field2[0].value );
                }
            }
            if ( col.type === 'date' || col.type === 'datetime' ) {
                this.dialogFG.addControl( `desde_${col.field}`, formControl );
                this.dialogFG.addControl( `hasta_${col.field}`, formControl2 );
            } else {
                this.dialogFG.addControl( col.field, formControl );
            }
        }
    }

    // Para mostrara el formulariO
    showDialog() {
        this.display = true;
    }

    // Para aplicar los filtros
    aplicarFiltro() {
        this.setSessionStorage();
        this.onItems();
        this.display = false;
    }

    // Para limpiar los filtros
    limpiarFiltro() {
        this.dialogFG.reset();
        this.setSessionStorage();
        this.onItems();
        this.display = false;
    }

    // Para mostrar el nombre del campo
    getDateFieldName( col: any, prefix: string ) {
        return `${prefix}_${col.field}`;
    }

    getSelectMulti( field: any ) {
        const selected = this.dialogFG.get(field);
        return selected.value;
    }

    getOptionLabel( options: any[], field: any ) {     
        let label = '';
        if ( options ) {
            for (const option of options) {
                if ( option.valor === field ) {
                    label = option.nombre;
                }
            }
        }
        return label;
    }

    getBGValue( options: any[], field: any ) {
        let bg = false;
        if ( options ) {
            const idx = options.findIndex( op => op.valor === field );
            if ( idx !== -1 ) {
                bg = options[idx].bg
            }
        }
        return bg;
    }

    filterData(target: any, blur?: boolean): void {
        this.dt?.filterGlobal(target.value, 'contains');
    }

    /**
     * Limpia el valor del filtro local.
     */
    clearFilterData(): void {
        this.filterValue = '';
        this.dt.filterGlobal(this.filterValue, 'contains');
    }

    onChangeBuscar() {
        if ( this.filterValue.length == 0 ) {
            this.onItems();
        }
    }

}
